module.exports = __webpack_public_path__ + "static/media/Raggruppa_74.c6edce3e.svg";